import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const Header = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isResourcesOpen, setIsResourcesOpen] = useState(false);
  const menuRef = useRef(null);
  const resourcesRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
        setIsResourcesOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close resources dropdown on mobile when menu closes
  useEffect(() => {
    if (!isMenuOpen) {
      setIsResourcesOpen(false);
    }
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleResources = (e) => {
    e.preventDefault();
    setIsResourcesOpen(!isResourcesOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsResourcesOpen(false);
  };

  return (
    <nav className="navbar navbar-expand-lg sticky-top" ref={menuRef}>
      <div className="container">
        {/* Logo + Brand */}
        <Link className="navbar-brand d-flex align-items-center gap-2" to="/">
          <div className="brand-logo">
            <div className="d-flex align-items-center gap-2">
              <img
                src="/images/logo.png"
                alt="FORMAX MONEY Logo"
                style={{ height: "40px", width: "auto" }}
              />
            </div>
          </div>
        </Link>

        {/* Mobile Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsible Menu */}
        <div className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`}>
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={closeMenu}>
                Home
              </Link>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/services" onClick={closeMenu}>
                Services
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/about-us" onClick={closeMenu}>
                About
              </a>
            </li>
            {/* <li className="nav-item">
              <a className="nav-link" href="#bc-agents" onClick={closeMenu}>
                BC Agents
              </a>
            </li> */}

            {/* Resources Dropdown with Submenu */}
            {/* <li className="nav-item dropdown" ref={resourcesRef}>
              <a
                className="nav-link dropdown-toggle"
                href="#"
                onClick={toggleResources}
                aria-expanded={isResourcesOpen}
              >
                Resources
              </a>
              <ul className={`dropdown-menu ${isResourcesOpen ? "show" : ""}`}>
                <li>
                  <a className="dropdown-item" href="#blog" onClick={closeMenu}>
                    <i className="fas fa-blog me-2"></i> Blog
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#faq" onClick={closeMenu}>
                    <i className="fas fa-question-circle me-2"></i> FAQ
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="#guides"
                    onClick={closeMenu}
                  >
                    <i className="fas fa-book me-2"></i> BC Agent Guides
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="#downloads"
                    onClick={closeMenu}
                  >
                    <i className="fas fa-download me-2"></i> Downloads
                  </a>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="#support"
                    onClick={closeMenu}
                  >
                    <i className="fas fa-headset me-2"></i> Support Center
                  </a>
                </li>
              </ul>
            </li> */}

            <li className="nav-item">
              <a className="nav-link" href="/contact-us" onClick={closeMenu}>
                Contact
              </a>
            </li>
          </ul>

          {/* Login Button - Replaces Get Started */}
          <a
            id="loginMock"
            className="btn btn-outline-gold ms-lg-3"
            onClick={() => {
              alert(
                "🔐 FORMAX MONEY - BC Agent Login Portal will be available soon. Contact support for registration.",
              );
            }}
          >
            <i className="fas fa-sign-in-alt me-2"></i>Login
          </a>
        </div>
      </div>

      {/* Mobile Menu Styles - Add to your CSS file */}
      <style jsx>{`
        @media (max-width: 991.98px) {
          .collapse {
            position: fixed;
            top: 70px;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(10, 37, 64, 0.98);
            backdrop-filter: blur(12px);
            z-index: 1050;
            padding: 2rem 1.5rem;
            overflow-y: auto;
            transition: all 0.3s ease;
            transform: translateX(100%);
          }

          .collapse.show {
            transform: translateX(0);
          }

          .navbar-nav {
            flex-direction: column;
            gap: 0.75rem;
          }

          .nav-link {
            color: white !important;
            font-size: 1.1rem;
            padding: 0.75rem 0;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          }

          .dropdown-menu {
            position: static !important;
            background: rgba(255, 255, 255, 0.1);
            border: none;
            padding: 0.5rem 0 0.5rem 1rem;
            margin-top: 0.5rem;
            width: 100%;
          }

          .dropdown-item {
            color: #ffde9e;
            padding: 0.5rem 0;
          }

          .dropdown-item:hover {
            background: rgba(212, 175, 55, 0.2);
            color: #d4af37;
          }

          .btn-outline-gold {
            margin-top: 1rem;
            text-align: center;
            display: inline-block;
            width: 100%;
          }

          .navbar-toggler {
            border: none;
            padding: 0.5rem;
          }

          .navbar-toggler:focus {
            box-shadow: none;
          }
        }

        @media (min-width: 992px) {
          .dropdown-menu {
            display: none;
            opacity: 0;
            transition: opacity 0.2s ease;
          }

          .dropdown-menu.show {
            display: block;
            opacity: 1;
          }
        }

        .brand-logo {
          display: inline-flex;
          align-items: center;
        }

        .brand-text {
          font-family: "Space Grotesk", monospace;
          font-weight: 800;
          font-size: 1.5rem;
          background: linear-gradient(135deg, #0a2540 0%, #d4af37 80%);
          background-clip: text;
          -webkit-background-clip: text;
          color: transparent;
        }

        @media (max-width: 576px) {
          .brand-text {
            font-size: 1.2rem;
          }
        }
      `}</style>
    </nav>
  );
};

export default Header;
